export enum eBrandImageSizes {
  Small = `pinecone-loading__icon-small`,
  Normal = `pinecone-loading__icon`,
  Large = `pinecone-loading__icon-large`,
}
